<template>
  <v-container>
    <v-row>
      <v-col cols="12">        
        <upload-media 
        :accept="this.accept" 
        @change="mediaChanged" 
        :listMedia="media"
        :influencer="influencer"
        :campaign="campaign"></upload-media>
        <div v-if="supportsVideoUpload" class="video-compression-suggestion mt-3">
          <v-icon small color="info" class="mr-1">mdi-information-outline</v-icon>
          <span>Video file too large?</span>
          <a
            href="https://www.veed.io/new?tool=compress"
            target="_blank"
            rel="noopener noreferrer"
            class="ml-1"
          >Compress your video with VEED</a>
          <span> &nbsp;before uploading.</span>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="isVideoLink" style="margin-bottom:0px !important;">
      <v-col cols="12" style="margin-bottom:0px !important;">
        <v-text-field         
        filled   
        clearable 
        type="text"
        label="Video or Drive Link (use this field if automatic upload do not work or your video file exceeds 100mb)"
        persistent-hint
        v-model="vdoLink"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="isRemark" style="margin-bottom:0px !important;">
      <v-col cols="12" style="margin-bottom:0px !important;">
        <v-textarea 
          name="remark" 
          label="Remark" 
          clearable 
          auto-grow
          filled
          rows="4"          
          v-model="remark"
          :rules="[rules.length(2200)]"
          counter>          
        </v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-textarea 
          name="caption" 
          :label="captionLabel" 
          clearable 
          auto-grow
          filled
          rows="4"          
          v-model="caption"
          :rules="[rules.length(2200)]"
          counter>          
        </v-textarea>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col cols="12">
        <v-textarea
          readonly 
          filled
          auto-grow        
          rows="4"           
          label="Mandatory Hashtag & Mentions"        
          v-model="hashTags"     
          counter       
          >
        </v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          readonly 
          filled
          auto-grow        
          rows="4"           
          label="Call to Action Links"        
          v-model="callToActionLinks"     
          counter       
          >
        </v-text-field>
      </v-col>
    </v-row>       -->
  </v-container>
</template>
<script>
import config from '@/config';
import UploadMedia from './UploadMedia';
import campaignHelper from '../../views/Campaign/campaignHelper';
import { mapState } from 'vuex';
export default {
  name: 'PostForm',
  data() {
    return {
      caption: null,
      vdoLink: null,
      remark: null,
      media: [],
      type: null,
      hashTags: '',
      callToActionLinks: '',
      rules: {
        length: len => v => (v || '').length <= len || `Character Length should not more than ${len}`,
        required: v => !!v || 'This field is required'
      },
      influencerRole: config.userRoles.INFLUENCER
    };
  },
  components: {
    UploadMedia
  },
  props: {
    post: Object,
    influencer: Object,
    campaign: Object
  },
  watch: {
    caption(value) {
      this.$emit('text-changed', value);
    },
    vdoLink(val) {
      this.$emit('vdo-link-changed', val);
    },
    remark(value) {
      this.$emit('remark-changed', value);
    },
    post(oval, val) {
      this.link = oval.vdoLink
      this.caption = oval.captionText
      this.type = oval.type
      this.media = oval.media
      this.remark = oval.remark
    },
    campaign: {
      handler: function(newValue) {
        if (newValue) {
          this.loadCampaign()
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.loadCampaign()
  },
  computed: {
    ...mapState({
      campaignDetail: state => state.campaign.campaignDetail
    }),
    accept() {
      switch (this.post.type) {
        case 'video':
          return 'image/*|video/*';
        case 'image':
          return 'image/*';
        case 'post/carousel':
          return 'image/*|video/*';
        case 'reel':
          return 'image/*|video/*';
      }
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isVideoLink() {
      return this.post.type === 'story' ||
      this.post.type === 'video' ||
      this.post.type === 'reel' ||
      this.post.type === 'tiktok' ||
      this.post.type === 'youtube' ||
      this.post.type === 'facebook'
    },
    supportsVideoUpload() {
      return this.isVideoLink || (this.accept || '').includes('video/*')
    },
    isRemark() {
      return this.post.type === 'story' && this.currentUserRole !== this.influencerRole
    },
    captionLabel() {
      return this.post.type === 'story' ? 'Story Caption' : 'Caption'
    }
  },
  methods: {
    mediaChanged(media) {
      this.$emit('media-changed', media);
    },
    async loadCampaign() {
      await this.$store.dispatch('campaign/getCampaignDetail', this.campaign.id)
      this.hashTags = campaignHelper.getMandatoryHashtagMentions(this.campaignDetail)
      this.callToActionLinks = this.campaignDetail.callToActionLinks || ''
    }
  }
};
</script>
<style scoped>
.video-compression-suggestion {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// PostForm.vue?4d18c87b